module.exports = __webpack_public_path__ + "34736292/img/trash-icon.ff8201c7.svg";